<template>
  <div class="olympicMusicShowEntryType">
    <ul>
      <li v-for="item in competitiontypes" :key="item.typeId" @click="selectCompetitiontypeHandle(item)">
        <div class="left">
          <div class="title">{{item.name}}</div>
          <div class="count">{{item.viewText}}</div>
          <div class="cate_list">
            <span class="cate"
              v-for="tag in item.tags"
              :key="tag"
            >{{tag}}</span>
          </div>
        </div>
        <div class="right">
          <van-icon name="arrow" size="24" />
        </div>
      </li>
    </ul>

    <div class="box">
      <div class="button btn3" @click="navToRecords">我的赛程</div>
    </div>
  </div>
</template>

<script>
import { Icon, Toast } from 'vant';

import { ApiQuerycompetitiontypes } from '@/api/olympicMusicShow.js'
import { getcompetition } from "@/api/competition";

export default {
  components: {
    vanIcon: Icon
  },
  name: 'olympicMusicShowEntryType',
  data() {
    return {
      CompetitionId: "",
      ChannelId: "",
    }
  },
  computed: {
    competitiontypes: {
      get() {
        return this.$store.state.olympicMusicShow.competitiontypes
      },
      set(value) {
        this.$store.commit('olympicMusicShow/setCompetitiontypes', value)
      }
    },
    selectCompetitiontype: {
      get() {
        return this.$store.state.olympicMusicShow.selectCompetitiontype
      },
      set(value) {
        this.$store.commit('olympicMusicShow/setSelectCompetitiontype', value)
      }
    },
    competitionId() {
      return this.$store.state.olympicMusicShow.competitionId
    }
  },
  mounted() {
    document.title = '参赛类型'

    this.getOlympicMusicShowEntryType()
    let isApp = this.$route.query.isApp
    this.CompetitionId = this.$store.state.olympicMusicShow.competitionId;
    this.ChannelId = this.$store.state.olympicMusicShow.channelId;
    if(isApp == 'true') {
      // app
      this.getUserInfo()
      this.getTokenInfo()
    }

    getcompetition({
      CompetitionId: this.CompetitionId,
      ChannelId: this.ChannelId,
    }).then((res) => {
      if (res.code == 200) {
        this.$store.commit('olympicMusicShow/setChannels', res.data.channels)
      } else {
        Toast(res.msg);
      }
    });
  },
  methods: {
    navToRecords() {
      this.$router.push({ path: "records" });
    },
    getOlympicMusicShowEntryType() {
      let params = {
        CompetitionId: this.competitionId
      }

      ApiQuerycompetitiontypes(params).then(res => {
        if (res.code === 200) {
          this.competitiontypes = res.data
        } else {
          this.competitiontypes = []
        }
      })
    },
    selectCompetitiontypeHandle(item) {
      this.$store.commit('olympicMusicShow/resetSingleForm')
      this.$store.commit('olympicMusicShow/resetMultiForm')

      this.selectCompetitiontype = item

      if (item.professionals.length === 0) {
        if (this.selectCompetitiontype && this.selectCompetitiontype.isSingle) {
          this.$router.push({ path: 'singleRegister', query: { typeId: item.typeId } })
        } else {
          this.$router.push({ path: 'multiRegister', query: { typeId: item.typeId } })
        }
      } else if (item.professionals.length > 1) {
        // 选择乐器
        this.$router.push({ path: 'instruments', query: { typeId: item.typeId } })
      } else {
        this.$store.commit('olympicMusicShow/setSelectProfessional', item.professionals[0])

        let groups = item.professionals[0].groups
        if (groups.length > 0) {
          this.$router.push({ path: 'group', query: { typeId: item.typeId, professionalId: item.professionals[0].professionalId } })
        } else {
          if (this.selectCompetitiontype && this.selectCompetitiontype.isSingle) {
            this.$router.push({ path: 'singleRegister', query: { typeId: item.typeId, professionalId: item.professionals[0].professionalId } })
          } else {
            this.$router.push({ path: 'multiRegister', query: { typeId: item.typeId, professionalId: item.professionals[0].professionalId } })
          }
        }
        
      }
    },
    // 约定APP方法-获取用户方法
    getUserInfo(){
      DYL.getUserInfo(window['success'] = (data) => {
        if(typeof data != 'object'){
          data = JSON.parse(data)
        }
        Store.commit('index/setUserInfo', {
          userId: data.id
        })
      })
    },
    // 约定APP方法-获取用户Token
    getTokenInfo(){
        DYL.getTokenInfo(window['success'] = (data) => {
          if (typeof data != 'object') {
            data = JSON.parse(data);
          }
          localStorage.setItem('appUserToken', data.access_token)
        })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/flexable.scss';

.olympicMusicShowEntryType {
  width: 100%;
  min-height: 100vh;
  padding-top: px2rem(30);
  padding-bottom: px2rem(68);
  background-color: #F5F5F9;
  box-sizing: border-box;
  .box {
    .button {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 25vw;
      height: 11.1vw;
      line-height: 11.1vw;
      color: #fff;
      font-size: 13px;
    }
    .btn3 {
      background: url(../../assets/competition_btn3.png) no-repeat;
      background-size: cover;
      bottom: 31.9vw;
    }
  }
  ul {
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: px2rem(20);
      width: 100%;
      height: px2rem(300);
      padding: px2rem(72) px2rem(46) 0 px2rem(40);
      background-color: #fff;
      box-sizing: border-box;
      &:last-child {
        margin-bottom: 0;
      }
      .left {
        .title {
          margin-bottom: px2rem(30);
          text-align: left;
          font-size: px2rem(36);
          font-weight: bold;
          color: #585858;
          line-height: 1;
        }
        .count {
          margin-bottom: px2rem(20);
          text-align: left;
          font-size: px2rem(26);
          font-weight: 500;
          color: #585858;
          line-height: 1;
        }
        .cate_list {
          display: flex;
          align-items: center;
          .cate {
            margin-right: px2rem(20);
            flex: 0 0 px2rem(63);
            height: px2rem(45);
            text-align: center;
            line-height: px2rem(45);
            font-size: px2rem(22);
            font-weight: 500;
            color: #FFFFFF;
            border-radius: px2rem(8);
            background-color: #3AC8CA;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>